import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { MAIN_SITE_URL } from "@/mocks/categories";
import Reveal from "@/components/base/Reveal";

const cardIcons = [
  "ri-star-line",
  "ri-truck-line",
  "ri-coupon-3-line",
  "ri-price-tag-3-line",
  "ri-archive-line",
  "ri-shield-check-line",
];

const cardKeys = [
  "card.review",
  "card.shipping",
  "card.coupon",
  "card.discount",
  "card.warehouse",
  "card.legit",
];

export default function Cards() {
  const { t } = useTranslation();

  return (
    <>
      <section className="bg-secondary-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
          <Reveal>
            <div className="text-center max-w-2xl mx-auto mb-10">
              <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-4xl">
                {t("cards.title")}
              </h2>
              <p className="text-foreground-600 mt-4 leading-relaxed">
                {t("cards.description")}
              </p>
            </div>
          </Reveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cardKeys.map((k, i) => (
              <Reveal key={k} delay={(i % 3) * 80}>
                <div className="h-full rounded-lg bg-background-50 border border-background-200 p-6 flex flex-col">
                  <div className="w-12 h-12 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center mb-5">
                    <i className={`${cardIcons[i]} text-2xl`}></i>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-lg mb-2">
                    {t(`${k}.title`)}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                    {t(`${k}.desc`)}
                  </p>
                  <a
                    href={MAIN_SITE_URL}
                    target="_blank"
                    rel="noopener nofollow"
                    className="inline-flex items-center gap-1.5 mt-5 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {t("exploreSpreadsheet")}
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <Reveal>
          <div className="rounded-lg bg-primary-500 text-background-50 p-8 md:p-12 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="font-heading font-bold text-2xl md:text-3xl leading-tight">
                {t("articleCta.title")}
              </h2>
              <p className="text-background-50/90 mt-4 leading-relaxed">
                {t("articleCta.desc")}
              </p>
            </div>
            <div className="flex justify-start lg:justify-end">
              <Link
                to="/usfans-spreadsheet-guide"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-background-50 text-primary-700 font-semibold text-base hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                {t("articleCta.button")}
                <i className="ri-arrow-right-line text-lg"></i>
              </Link>
            </div>
          </div>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-8 pb-16 md:pb-24">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-4xl">
              {t("finalCta.title")}
            </h2>
            <p className="text-foreground-600 mt-4 leading-relaxed">
              {t("finalCta.desc")}
            </p>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-8 px-8 py-4 rounded-md bg-accent-500 text-background-50 font-semibold text-base hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t("finalCta.button")}
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
          </div>
        </Reveal>
      </section>
    </>
  );
}